import React, { FC } from 'react'

import DiamongLeagueLogo from 'assets/diamong-league-logo.png'
import SportallLogo from 'assets/sportall-logo.png'
import WecLogo from 'assets/logo-fiawec.png'
import FFAthleLogo from 'assets/logo-ffathle.png'
import classnames from 'classnames'
import { auth } from 'services'
import { config } from 'config'

export interface HeaderProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  showCustomerLogos?: boolean
}
export const Header: FC<HeaderProps> = ({
  children,
  className,
  showCustomerLogos = false,
  ...props
}) => {
  return (
    <div
      className={classnames('flex py-4 px-6 h-20 md:h-28', className)}
      {...props}
    >
      {showCustomerLogos && (
        <>
          <div className="flex items-center justify-center space-x-4">
            <a
              href="https://www.athle.fr"
              target="_blank"
              rel="noreferrer"
              className="h-10"
            >
              <img
                className="float-left object-contain h-full"
                src={FFAthleLogo}
                alt="diamond league"
              />
            </a>
            <div className="py-10">
              <a
                href="https://www.diamondleague.com/"
                target="_blank"
                rel="noreferrer"
              >
                <div className="h-10">
                  <img
                    className="float-left object-contain h-full"
                    src={DiamongLeagueLogo}
                    alt="diamond league"
                  />
                </div>
              </a>
            </div>
          </div>
        </>
      )}
      <div className="flex-1"></div>
      {auth.currentUser && (
        <div className="flex items-center justify-center mx-4">
          <div
            className="text-white underline cursor-pointer"
            onClick={() => auth.signOut()}
          >
            logout
          </div>
        </div>
      )}
      {config.isWecRedbutton ? (
        <a href="https://fiawec.tv/" rel="noreferrer">
          <div className="flex items-center justify-end h-full">
            <img
              src={WecLogo}
              alt="wec logo"
              className="float-right object-contain h-full"
            />
          </div>
        </a>
      ) : (
        <a href="https://www.sportall.tv" rel="noreferrer">
          <div className="flex items-center justify-end h-full">
            <img
              src={SportallLogo}
              alt="sportall"
              className="float-right object-contain h-full"
            />
          </div>
        </a>
      )}
    </div>
  )
}
